import '!ng-cache-loader!./TelegramTutorial.html';
import { ChannelBaseController } from '../ChannelBaseController';
import { ChannelsNames } from '../Channels';
export class TelegramController extends ChannelBaseController {
    static $inject = ['LoadingService', 'BlipToastService', '$translate', 'SegmentService', 'application', 'ChannelsService', 'ApplicationService2'];
    constructor(LoadingService, BlipToastService, $translate, SegmentService, application, ChannelsService, ApplicationService2) {
        'ngInject';
        super(ChannelsNames.Telegram, ChannelsService, ApplicationService2, application);
        this.LoadingService = LoadingService;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.SegmentService = SegmentService;
        this.application = application;
        this.ChannelsService = ChannelsService;
        this.ApplicationService2 = ApplicationService2;
        this.channelAvaliableOnToggle = async (event) => {
            this.isActive = event.detail.checked;
            if (!event.detail.checked) {
                await this.disableChannel();
            }
        };
        this.onInputTokenChange = (event) => {
            this.channel.configurations.Token = event.detail.value;
        };
    }
    async save() {
        try {
            this.channelForm.$setPristine();
            this.LoadingService.startLoading();
            await this.updateChannel();
            this.BlipToastService.show('success', {
                msg: await this.$translate('utils.successMsg.8'),
            });
            this.SegmentService.createTrack('publish-chatbot', {
                channel: 'Telegram',
                botName: this.application.name,
            });
        }
        catch (e) {
            console.error(e);
            this.BlipToastService.show('danger', {
                msg: await this.$translate('utils.errorMsg.50'),
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async disableChannel() {
        if (!this.isNew) {
            this.SegmentService.createTrack('unpublish-chatbot', {
                channel: 'Telegram',
                botName: this.application.name,
            });
        }
        this.LoadingService.startLoading();
        try {
            await this.updateChannel();
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
}
TelegramController.$inject = ['LoadingService', 'BlipToastService', '$translate', 'SegmentService', 'application', 'ChannelsService', 'ApplicationService2'];
